'use client';

import { useMounted } from 'Shared/hooks/useMounted';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Box, Column } from '@viewup/ui';
import { AuthBox } from '../../../../_components/AuthBox';
import { AccountMenus } from '../AccountMenus';
import { HelpAndLogout } from '../HelpAndLogout';
import { SupportMenus } from '../SupportMenus';
import { ViewerInformation } from '../ViewerInformation';

export const MyViewupClientPage = () => {
  const { accessToken } = useTokenStore();
  const isMounted = useMounted();

  if (!isMounted) return;
  return (
    <Column bgColor='bg.disabledLight' gap={12}>
      {accessToken ? (
        <ViewerInformation />
      ) : (
        <Box bgColor='bg.primary'>
          <AuthBox />
        </Box>
      )}
      {accessToken && <AccountMenus />}
      <SupportMenus />
      <HelpAndLogout />
    </Column>
  );
};
